import logo from './logo.svg';
import './App.css';
import StudentList from './Components/CredentialsFormatter';

function App() {
  return (
    <div className="App">
      <StudentList/>
      
    </div>
  );
}

export default App;
